// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileSubMenuHead_root__lEuue","arrow":"MobileSubMenuHead_arrow__CNyYX","title":"MobileSubMenuHead_title__jJbkP"};